"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var isObject = function isObject(obj) {
  return Object.prototype.toString.call(obj) === '[object Object]';
};

var isFunction = function isFunction(obj) {
  return typeof obj === 'function';
};

var empty = function empty(obj) {
  if (isObject(obj)) {
    return {};
  } else if (Array.isArray(obj)) {
    return [];
  }
};

var keys = function keys(obj) {
  if (isObject(obj)) {
    return Object.getOwnPropertyNames(obj);
  } else {
    return Object.keys(obj);
  }
};

function defineProperties(obj, root) {
  var next = empty(obj);
  var props = keys(obj);

  if (!root) {
    root = next;
  }

  var _loop_1 = function _loop_1(key) {
    var value = obj[key];

    if (isFunction(value)) {
      Object.defineProperty(next, key, {
        get: function get() {
          return value(root);
        },
        configurable: false
      });
      return "continue";
    }

    if (Array.isArray(value) || isObject(value)) {
      Object.defineProperty(next, key, {
        value: defineProperties(value, root),
        configurable: false
      });
      return "continue";
    }

    Object.defineProperty(next, key, {
      value: value,
      configurable: false
    });
  };

  for (var _i = 0, props_1 = props; _i < props_1.length; _i++) {
    var key = props_1[_i];

    _loop_1(key);
  }

  return next;
}

exports.deepComputed = function (obj) {
  return defineProperties(obj);
};